function handleAudioPlayError(_soundId: number, error: unknown): void {
  console.error('Failed to play sound', error)
}

export default handleAudioPlayError
